/**
 * Plateforme multi-clubs (squash_manger_api_v2/docs/MULTITENANT_PLAN.md) : nom de la plateforme, à ne changer qu'ici (ou par
 * `REACT_APP_PLATFORM_NAME`). C'est aussi le nom de l'app joueur (choisi par la Ligue) ; à ne pas confondre avec le nom du club (`/ClubConfig/public`). L'API
 * expose le même nom (`GET /Platform/info`, réglage `Platform:Name`).
 */
export const PLATFORM_NAME = (process.env.REACT_APP_PLATFORM_NAME || '').trim() || 'MyLFS';
